<div class="pnf_container">
    <div class="pnf_lottie">
        <ng-lottie containerClass="moving-box another-class"
                   [options]="options"></ng-lottie>
    </div>
    <nz-divider nzType="vertical"></nz-divider>
    <div class="pnf_box">
        <h1>404</h1>
        <h3>(Page Not Found)</h3>
        <p>Oops! Non troviamo la pagina che stai cercando.<br>
            Potrebbe essere un vecchio link oppure uno sbagliato.</p>

        <button nz-button nzType="primary" (click)="navigateToRoot()">Torna Indietro</button>
        <button class="pnf_fatti_aiutare" nz-button nzType="link" [routerLink]="'/dashboard'">Vai alla Home</button>
    </div>
</div>

